import { AttrField, BelongsToField, OrmModel, StringField } from 'vuex-orm-decorators'
import { isString } from 'lodash-es'
import { modelNames } from '@/data/models/types'
import TemplateCategory from '@/data/models/domain/TemplateCategory'
import BaseModel from '@/data/models/BaseModel'
import type { StripoTemplate } from '@/services/stripo/types'
import TmLogicError from '@/core/error/tmLogicError'

export type EmailTemplateStripoSection = {
  html?: string
  css?: string
  utmSource?: string
  utmMedium?: string
  utmCampaign?: string
  utmContent?: string
  utmTerm?: string
  customUtms?: Record<string, string>
}

@OrmModel(modelNames.EMAIL_TEMPLATE)
export class EmailTemplate extends BaseModel {
  @StringField()
  public name: string

  @StringField()
  public body: string

  @StringField()
  public categoryId: string

  @BelongsToField(TemplateCategory, 'categoryId')
  public category: TemplateCategory

  @StringField()
  public createdAt: string

  @StringField()
  public updatedAt: string

  @StringField(null)
  public usedAt: string | null

  @AttrField(null)
  public stripo: EmailTemplateStripoSection | null

  public getStripoSourceTemplate(): StripoTemplate {
    if (!this.isStripoTemplate()) {
      throw new TmLogicError(`EmailTemplate "${this.id}" is not a Stripo template`)
    }
    return {
      html: this.stripo.html,
      css: this.stripo.css,
      utm: {
        utmSource: this.stripo.utmSource,
        utmMedium: this.stripo.utmMedium,
        utmCampaign: this.stripo.utmCampaign,
        utmContent: this.stripo.utmContent,
        utmTerm: this.stripo.utmTerm,
        customUtms: this.stripo?.customUtms
          ? Object.entries(this.stripo.customUtms).map(([name, value]) => ({ name, value }))
          : [],
      },
    }
  }

  public isStripoTemplate(): this is EmailTemplate & { stripo: Required<EmailTemplateStripoSection> } {
    return isString(this.stripo?.html) && isString(this.stripo?.css)
  }
}
